import { createAction, createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';
import { type SagaConfig } from '@sagas/request/types';

import { type EntityJurisdictionsState } from './types';

export const initialState: EntityJurisdictionsState = {
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
  },
  model: {},
};

export const entityJurisdictionsRequest = createAction<{
  sagaConfig?: SagaConfig;
  entityIds: Array<string>;
}>('entityJurisdictions/request');

const entityJurisdictions = createSlice({
  name: 'entityJurisdictions',
  initialState,
  reducers: {
    reset: () => initialState,
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload.result;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
  },
  extraReducers: builder => {
    builder.addCase(entityJurisdictionsRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    });
  },
});

export const {
  reset: entityJurisdictionsReset,
  success: entityJurisdictionsSuccess,
  failure: entityJurisdictionsFailure,
} = entityJurisdictions.actions;

export default entityJurisdictions.reducer;
